import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull, validatePorcentagem } from '@/functions/Util';

export default class LimiteCreditoValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;
        
        if (isNull(model.idsaldoclienteerp)) {
			refs.idErpInput.focusedOut = true;
			validated = false;
		}
		if (isNull(model.idempresa)) {
			refs.empresaInput.focusedOut = true;
			validated = false;
		}
		if (isNull(model.creditoliberado)) {
			refs.creditoliberadoInput.focusedOut = true;
			validated = false;
		}
		if (isNull(model.saldodevedor)) {
			refs.saldodevedorInput.focusedOut = true;
			validated = false;
		}
		if (isNull(model.limitebonificacao)) {
			refs.limitebonificacaoInput.focusedOut = true;
			validated = false;
		}
		if (
			isNull(model.limitebonificacaop) ||
			(!isNull(model.limitebonificacaop) && !validatePorcentagem(model.limitebonificacaop))
		) {
			refs.LimiteBonificacaoPInput.focusedOut = true;
			validated = false;
		}
		return validated;
	}
}
